var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SpringCalendar',{attrs:{"year":"2020","default-type":"week","color":"#5118ac","show":"month","events":_vm.events,"locale":"en","start-of-week":"0","labels-config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }